import useJumboLayoutSidebar from "@jumbo/hooks/useJumboLayoutSidebar";
import { HomeOutlined } from "@mui/icons-material";
import { Avatar, Box, Button, CircularProgress, Grid, Typography } from '@mui/material';
import { deleteObjectApi, getObjectListByPropertyApi } from 'api/general';
import AddUpdateVoteCard from 'app/components/Card/AddUpdateVoteCard';
import VoteStatusCard from 'app/components/Card/VoteStatusCard';
import { getLocaleDateWithTimeCustom, getLocaleDateWithTimeCustomV2, getUserFullName, sortByProperty } from 'app/utils/appHelpers';
import { DECISION, MEETING_USER, VOTE } from 'app/utils/constants/customConstant';
import { redColor } from 'config';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';
import DashboardPageToolBar from './DashboardPageToolBar';
import { setCurrentMeeting, setCurrentMeetingUsers } from "stores/meeting";
import LoadingPopUp from 'app/components/LoadingPopup';
import config from "config";
import DshReviewVoteTitle from "app/components/Box/DshReviewVoteTitle";

const VotePage = () => {
    const navigate = useNavigate();
    const { sidebarOptions, setSidebarOptions } = useJumboLayoutSidebar(); // sol menu click
    const { authUser } = useSelector(state => state.auth);
    const currentMeeting = useSelector((state) => state.meeting.currentMeeting);
    const [loading, setLoading] = useState(false);
    const [decisionsOfTheMeeting, setDecisionsOfTheMeeting] = useState([]);
    const [votesOfTheMeeting, setVotesOfTheMeeting] = useState([]);
    const [voteInputStatus, setVoteInputStatus] = useState(false);
    const [filteredDecisions, setFilteredDecisions] = useState(null);
    const userList = useSelector(state => state.user.data || []);


    const dispatch = useDispatch();

    useEffect(() => {
        const getAPI = async () => {
            setLoading(true);
            try {
                const res = await getObjectListByPropertyApi(DECISION, "meetingId", currentMeeting.id)
                setDecisionsOfTheMeeting(sortByProperty(res.data, "decisionNo"))

                let res2 = await getObjectListByPropertyApi(VOTE, "meetingId", currentMeeting.id)
                setVotesOfTheMeeting(res2.data);

                let res3 = await getObjectListByPropertyApi(MEETING_USER, "meetingId", currentMeeting.id)

                let data = res3.data.filter(item => item.type === 1)
                data = sortByProperty(data, "indexNo")
                dispatch(setCurrentMeetingUsers(data));

                setFilteredDecisions(sortByProperty(res.data, "decisionNo"));

            } catch (error) {
                console.error("Hata:", error);
            } finally {
                setLoading(false);
            }
        };
        getAPI();
    }, []);



    const addAfterTable = (item) => {
        let tmp = votesOfTheMeeting; tmp.unshift(item); setVotesOfTheMeeting(tmp)
        setVoteInputStatus(true)
    }

    const handleDelete = async (vote) => {

        const result = await deleteObjectApi(VOTE, vote.id);

        if (result.status) {

            const filteredList = votesOfTheMeeting.filter(x =>
                !(x.id === vote.id)
            );
            setVotesOfTheMeeting(filteredList);
            setVoteInputStatus(true)
            return result
        } else {
            return null;
        }
    };

    const updateAfterTable = (item) => {
        let tmp = votesOfTheMeeting;
        const index = votesOfTheMeeting.findIndex(x => x.id === item.id);
        index !== -1 ? tmp[index] = item : tmp.push({ ...item, id: Number(votesOfTheMeeting[votesOfTheMeeting.length - 1].id) + 1 })
        setVotesOfTheMeeting([...tmp]);
        setVoteInputStatus(true)

    }

    const handleHomeClick = () => {
        const unvotedDecisions = decisionsOfTheMeeting.filter(item =>
            !votesOfTheMeeting.some(vote =>
                vote.userId === authUser.id && vote.decisionId === item.id
            )
        );

        unvotedDecisions.length > 0 ?
            Swal.fire({
                html: `
                 <h4>Aşağıdaki karar(lar)a oy vermediniz!</h4>
                <ul style="list-style-type: none; padding: 0; max-height: 300px; overflow-y: auto; font-size: 13px;">
                    ${unvotedDecisions.map(decision => `
                        <li style="margin-bottom: 5px;">
                    Karar Maddesi: <span style="color: ${redColor}">${decision.decisionNo}</span>
                        </li>
                    `).join("")}
                </ul>
                <p>Ana Sayfaya dönmek istediğinizden emin misiniz?</p>
            `,
                customClass: {
                    container: 'swal-container-custom'
                },
                icon: 'question',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Evet',
                cancelButtonText: "Vazgeç"
            }).then(async (result) => {
                if (result.isConfirmed) {
                    dispatch(setCurrentMeetingUsers([]))
                    dispatch(setCurrentMeeting({}))
                    navigate("/")
                    setSidebarOptions({ open: true })
                }
            })

            :

            Swal.fire({
                position: 'center',
                icon: 'success',
                text: "Tüm kararlara oy verdiniz",
                showConfirmButton: false,
                timer: 2000
            }).then(async () => {
                navigate("/")
                setSidebarOptions({ open: true })
            })
    }



    const fontSettings = useSelector((state) => state.meeting.fontSettings);
    const { baseFontSize } = fontSettings
    const adminUser = userList.find(item => item.id === currentMeeting.adminUserId);


    return (

        <>
            <LoadingPopUp open={loading} />

            {!loading && <Box sx={{ fontSize: baseFontSize }}>
                <Box
                    sx={{
                        position: "sticky",
                        top: "75px",
                        zIndex: 1100,
                        backgroundColor: "#fff",
                        boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
                        p: 1,
                        borderRadius: "20px",
                        maxHeight: "80px",
                        marginBottom: 1,
                    }}
                >
                    <Box
                        sx={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                            width: "100%",
                        }}
                    >
                        <DshReviewVoteTitle
                            currentMeeting={currentMeeting}
                            adminUser={adminUser}
                        />

                        <Box
                            sx={{
                                display: "flex",
                                alignItems: "center",
                                gap: 2,
                            }}
                        >
                            <DashboardPageToolBar
                                data2={decisionsOfTheMeeting}
                                setData={setFilteredDecisions}
                            />
                            <Button onClick={() => handleHomeClick()} sx={{ whiteSpace: 'nowrap' }}>
                                <HomeOutlined sx={{ fontSize: 20 }} /> Ana Sayfa
                            </Button>
                        </Box>
                    </Box>
                </Box>


                {filteredDecisions !== null &&
                    filteredDecisions.map((decision, index) => {
                        const voteOfTheUser = votesOfTheMeeting.find(
                            (item) => item.decisionId === decision.id && item.userId === authUser.id
                        );

                        let filteredList = votesOfTheMeeting.filter(
                            (item) => item.decisionId === decision.id
                        );

                        // filteredList.forEach((element) => {
                        //     const user = userList.find((item) => item.id === element.userId);
                        //     element.user = user;
                        // });


                        return (
                            <Grid container spacing={1} sx={{ marginBottom: 1 }} key={decision.id}>
                                <Grid item xs={12} md={6} lg={8}>
                                    <AddUpdateVoteCard
                                        voteOfTheUser={voteOfTheUser}
                                        setVoteInputStatus={setVoteInputStatus}
                                        handleDelete={handleDelete}
                                        decision={decision}
                                        index={decision.id}
                                        addAfterTable={addAfterTable}
                                        updateAfterTable={updateAfterTable}
                                    />
                                </Grid>

                                <Grid item xs={12} md={6} lg={4}>
                                    <VoteStatusCard
                                        setVoteInputStatus={setVoteInputStatus}
                                        votesOfTheMeeting={filteredList}
                                    />
                                </Grid>
                            </Grid>
                        );
                    })
                }
            </Box>
            }
        </>
    );
}
export default VotePage;

